export const enum WelcomeActionType {
  GET_WELCOME = 'GET_WELCOME',
}
